import { Truck, Snowflake, MapPin, Clock } from 'lucide-react';
import useReveal from '@/hooks/useReveal';

const items = [
  {
    icon: Truck,
    title: 'Refrigerated Fleet',
    body: 'Temperature-tracked vans servicing Perth metro & surrounding regions.',
  },
  {
    icon: Snowflake,
    title: 'Frozen & Chilled',
    body: 'Held at −18°C frozen or 4°C chilled — cold-chain unbroken from cutting room to your back-of-house.',
  },
  {
    icon: Clock,
    title: 'Next-Day Standard',
    body: 'Order by 2pm for next-business-day delivery. Same-day for trade partners.',
  },
  {
    icon: MapPin,
    title: '15 Action Rd, Malaga WA 6090',
    body: 'Walk-in trade welcome. Pick-up by appointment from our cutting room. Call 0435 111 667.',
  },
];

export default function Delivery() {
  const reveal = useReveal();
  return (
    <section
      id="delivery"
      ref={reveal}
      className="mw-reveal relative py-24 sm:py-32"
    >
      <div className="max-w-screen-2xl mx-auto px-6 sm:px-10 lg:px-16">
        <div className="flex items-center gap-3 mb-4">
          <span className="block w-10 h-px bg-white/40" />
          <span className="text-[10px] uppercase tracking-[0.32em] text-white/55">
            Delivery · 004
          </span>
        </div>
        <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl text-white leading-[0.95] tracking-tight max-w-3xl">
          Cold-chain delivered.
          <br />
          <em className="not-italic text-[var(--mw-primary)]">On time</em>, every time.
        </h2>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {items.map((it) => {
            const Icon = it.icon;
            return (
              <div
                key={it.title}
                className="bg-[var(--mw-bg)] p-8 lg:p-10 hover:bg-[var(--mw-surface)] transition-colors duration-300"
              >
                <Icon size={28} className="text-[var(--mw-primary)]" strokeWidth={1.4} />
                <h3 className="mt-6 font-display text-2xl text-white">{it.title}</h3>
                <p className="mt-3 text-sm text-white/60 leading-relaxed">{it.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
